<div>
  @for (cart of shopService.carts(); track cart.id) {
  <div class="shadow-sm rounded p-3 mb-3">

    @if (cart.expired) {
      <span class="badge bg-danger" style="float: inline-end;">Expired</span>
    }
    
    <div class="d-flex gap-3">
      <div class="fw-bold w-20">Customer</div>
      <div>{{ cart.account.name }}</div>
    </div>
    <div class="d-flex gap-3">
      <div class="fw-bold w-20">Listing</div>
      <div>{{ cart.inventoryListing.name }}</div>
    </div>
    <div class="d-flex gap-3">
      <div class="fw-bold w-20">Ship Date</div>
      <div>{{ cart.shippingDate }}</div>
    </div>

    <div class="accordion accordion-flush my-5" id="accordionCartItems">
      @for (item of cart.items; track item.id) {

        <div class="accordion-item">
          <h2 class="accordion-header" [id]="'flush-heading-' + item.id">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              [attr.data-bs-target]="'#flush-collapse-' + item.id" aria-expanded="false" [attr.aria-controls]="'flush-collapse-' + item.id">
              
              <div class="d-flex align-items-center">

                <div style="width: 40px;">                           
                  <img [src]="sharedService.noImage" alt="Product Image" style="width: 30px; height: 30px; border-radius: 25%" [style.opacity]="false ? '1' : '0.2'" />
                </div>
                <div style="width: 265px; line-height: 1em;">
                  <div class="text-truncate">{{ item.product.name }}</div>
                  <small class="text-muted">
                    {{ item.fullPackage }}
                  </small>
                </div>
                <div style="width: 50px; text-align: end;">
                  <span class="fw-bold fs-6">{{ item.quantity | number }} </span>
                  <small>{{ item.quantityUnit }}</small>
                </div>
                
                <div style="width: 95px; text-align: end; margin-right: 5px;">
                  <span class="fw-bold">{{ item.grossAmount | currency }}</span>
                </div>
                <i class="fa-solid fa-times me-2" style="color: #DB302F;" (click)="shopService.deleteCartItems({ shoppingCartId: cart.id, ids: [item.id] }).subscribe()"></i>  
              </div>

            </button>
          </h2>
          <div [id]="'flush-collapse-' + item.id" class="accordion-collapse collapse" [attr.aria-labelledby]="'flush-heading-' + item.id">
            <div class="accordion-body">

              <ul class="list-group list-group-flush">
                <li class="list-group-item d-flex justify-content-between align-items-start py-1">
                  <div class="ms-2 me-auto">
                    Unit Price
                  </div>
                  <div class="text-end">
                    <span>{{ item.unitPrice | currency }}</span>
                    <small>/{{ item.priceUnit }}</small>
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start py-1">
                  <div class="ms-2 me-auto">
                    Amount
                  </div>
                  <div class="text-end">
                    <span>{{ item.amount | currency }}</span>
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start py-1">
                  <div class="ms-2 me-auto">
                    Charges
                  </div>
                  <div class="text-end">
                    <span>{{ item.charges | currency }}</span>
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start py-1">
                  <div class="ms-2 me-auto">
                    Discounts
                  </div>
                  <div class="text-end">
                    <span>{{ item.discounts | currency }}</span>
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start py-1">
                  <div class="ms-2 me-auto fw-bold fs-6">
                    Total
                  </div>
                  <div class="text-end fw-bold">
                    <span>{{ item.grossAmount | currency }}</span>
                  </div>
                </li>               
              </ul>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="d-flex gap-2 justify-content-end">

      @if (!cart.expired) {
      <button class="btn btn-success btn-sm" (click)="shopService.checkOutCarts({ids: [cart.id]}).subscribe()">
        <i class="fa-solid fa-bolt me-1"></i>
        Quick Buy
      </button>
      <button class="btn btn-primary btn-sm" (click)="goToCheckout(cart.id)">
        <i class="fa-regular fa-circle-check me-1"></i>
        Check Out
      </button>
      }

      <button class="btn btn-secondary btn-sm" (click)="shopService.deleteCarts([cart.id]).subscribe()">
        <i class="fa-solid fa-trash me-1"></i>
        Delete
      </button>
    </div>
  </div>
  }
</div>